export const DEPO_SUCCESS = 'DEPO_SUCCESS';
export const DEPO_LOADING = 'DEPO_LOADING';
export const DEPO_FAILED = 'DEPO_FAILED';
export const DEPO_LOAD = 'DEPO_LOAD';
export const DEPO_CREATE = 'DEPO_CREATE';
export const DEPO_UPDATE = 'DEPO_UPDATE';
export const DEPO_SHOW_MODAL = 'DEPO_SHOW_MODAL';
export const DEPO_HIDE_MODAL = 'DEPO_HIDE_MODAL';
export const DEPO_ALL_SUCCESS = 'DEPO_ALL_SUCCESS';
export const DEPO_LOAD_ALL = 'DEPO_LOAD_ALL';